module.exports = __webpack_public_path__ + "img/20f020d.png";